import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { Radar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { ConnectForm } from '@/components/ConnectForm';
import { WebsitePicker } from '@/components/WebsitePicker';
import { useWebsites } from '@/hooks/use-websites';
import { clearToken, getToken, setToken } from '@/lib/auth';

export const Route = createFileRoute('/connect')({ component: Connect });

function Connect() {
  const navigate = useNavigate();
  const [token, setTok] = useState(getToken() ?? '');
  const websites = useWebsites();

  return (
    <div className="flex min-h-screen items-center justify-center bg-secondary/30 p-6">
      <div className="w-full max-w-md space-y-8">
        {/* Brand wordmark */}
        <div className="flex flex-col items-center gap-3">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary shadow-md">
            <Radar className="h-7 w-7 text-primary-foreground" aria-hidden />
          </span>
          <h1 className="text-3xl tracking-tight">
            <span className="font-medium">slim</span>
            <span className="font-extrabold">SCOUT</span>
          </h1>
          <p className="text-sm text-muted-foreground">AI Trend Intelligence</p>
        </div>

        {/* Token connect card */}
        <Card className="shadow-sm">
          <CardHeader>
            <CardTitle>Verbinden</CardTitle>
          </CardHeader>
          <CardContent className="space-y-5">
            <ConnectForm
              initialToken={token}
              onSave={(t) => {
                setToken(t);
                setTok(t);
                websites.refetch();
              }}
            />

            {token && websites.isLoading && (
              <Skeleton className="h-10 w-full" />
            )}
            {token && websites.isError && (
              <p className="text-sm text-destructive">
                Konnte Websites nicht laden — Token prüfen.
              </p>
            )}
            {token && websites.isSuccess && (
              <WebsitePicker
                websites={websites.data}
                onSelect={(id) =>
                  navigate({ to: '/websites/$websiteId/gaps', params: { websiteId: id } })
                }
              />
            )}
            {token && (
              <Button
                variant="ghost"
                size="sm"
                className="w-full text-muted-foreground"
                onClick={() => {
                  clearToken();
                  setTok('');
                }}
              >
                Token zurücksetzen
              </Button>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
